import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.funding_requirements.commission_consent_title',
        defaultMessage: 'Introducer Commission'
    },
    caption: {
        id: '_.funding_requirements.commission_consent_caption',
        defaultMessage:
            'View and agree the commission paid to your introducer by iwoca.'
    },
    action: {
        id: '_.funding_requirements.commission_consent_action',
        defaultMessage: 'View & Agree'
    },
    completedAction: {
        id: '_.funding_requirements.commission_consent_completed_action',
        defaultMessage: 'View'
    }
});
